import { Box, Button, Grid, InputAdornment, Stack, TextField, Typography, useTheme } from '@mui/material';
import { debounce, get, isArray, isString, pickBy } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Search, Sliders } from 'react-feather';
import { useNavigate, useSearchParams } from 'react-router-dom';
import IconFeather from 'src/components/common/Icon';
import { useQueryParams } from 'src/hooks/useQueryParam';
import { FormType, useFormSearch } from 'src/zustand/useFormSearch';
import FormSearchHsCode from 'src/components/Form/FormSearchHsCode';
import FormItemCountry from 'src/components/Form/FormItemCountry';
import FormikForm from 'src/components/common/FormikForm';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { ISearchGlobalTradeDataQueryParams, TypeGlobalTradeDataFormSearch } from 'src/utils/typings/dto/tradeData';
import { handleQueryParamFromObject } from 'src/utils/helpers/queryParam';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { useQueryListTradeDataHSCode } from 'src/services/queries/useQueryTradeData';

const FilterTradeDataProductList = () => {
  // const query = useQueryParams();
  // const { t } = useTranslation();
  // const { handleOpenSearch } = useFormSearch((state) => state);
  // const [defaultQuery, setDefaultQuery] = useState(query?.company_name);
  // const params = useQueryParams();
  // const navigate = useNavigate();
  //
  // const getDefaultValue = (key: string) => {
  //   return get(params, key, '') as string;
  // };
  //
  // const formik = useFormik<TypeGlobalTradeDataFormSearch>({
  //   enableReinitialize: true,
  //   initialValues: {
  //     hs_code: getDefaultValue('hs_code'),
  //     import_country: getDefaultValue('imp_country_code'),
  //     export_country: getDefaultValue('exp_country_code'),
  //   },
  //   onSubmit: async (values, { setSubmitting }) => {},
  // });
  //
  // const [hsCodeSearchKeyword, setHSCodeSearchKeyword] = useState(formik.values.hs_code);
  // const [hsCodeValue, setHSCodeValue] = useState<ITradeDataProductItem | null>(null);
  //
  //
  // const dataHSCodeOptionsResp = useQueryListTradeDataHSCode(
  //   {
  //     country_code: formik.values.import_country,
  //     keyword: hsCodeSearchKeyword,
  //     limit: 50,
  //   },
  //   true,
  // );
  //
  // useEffect(() => { // Init logic for HS code
  //   if(formik.touched.hs_code) return;
  //   if(dataHSCodeOptionsResp.data?.data && hsCodeSearchKeyword && !hsCodeValue) {
  //     setHSCodeValue(dataHSCodeOptionsResp.data?.data?.find((item) => item.code === formik.values.hs_code) || null)
  //   }
  // }, [dataHSCodeOptionsResp, hsCodeSearchKeyword, hsCodeValue, formik.values.hs_code, formik.touched.hs_code]);
  //
  //
  // useEffect(() => {
  //   const newParams: ISearchGlobalTradeDataQueryParams = {
  //     ...params,
  //     hs_code: formik.values.hs_code,
  //     imp_country_code: formik.values.import_country,
  //     exp_country_code: formik.values.export_country,
  //   };
  //   const searchString = handleQueryParamFromObject(pickBy(newParams, Boolean));
  //   navigate({ pathname: AuthRouteKeys.TradeDataProductList, search: searchString });
  // }, [formik.values.hs_code, formik.values.import_country, formik.values.export_country]);
  //
  // useEffect(() => {
  //   if (query?.company_name) {
  //     setDefaultQuery(query?.company_name);
  //   }
  // }, [query?.company_name]);
  //
  // return (
  //   <Grid sx={{ placeItems: 'center' }} spacing={3} container>
  //     <Grid sm={12} md={8} lg={8} xl={9} item>
  //       <FormikForm formik={formik}>
  //         <Stack direction={'row'} spacing={2}>
  //           <Box flex={1}>
  //             <FormSearchHsCode
  //               id={'hs_code'}
  //               inputValue={hsCodeSearchKeyword}
  //               value={hsCodeValue}
  //               options={dataHSCodeOptionsResp.data?.data}
  //               onChange={(value: any) => {
  //                 setHSCodeValue(value)
  //                 formik.setFieldValue('hs_code', value?.code)
  //                 formik.setFieldTouched('hs_code')
  //               }}
  //               onTextInputChange={(value: string) => {
  //                 setHSCodeSearchKeyword(value)
  //               }}
  //               loading={dataHSCodeOptionsResp.isFetching}
  //             />
  //           </Box>
  //           <Box flex={1} display={'flex'} flexDirection={'row'} gap={2}>
  //             <FormItemCountry id={'export_country'} label={t('trade_data.search_form.input.export_country')} />
  //             <FormItemCountry id={'import_country'} label={t('trade_data.search_form.input.import_country')} />
  //           </Box>
  //         </Stack>
  //       </FormikForm>
  //     </Grid>
  //     <Grid sm={12} md={4} lg={4} xl={3} item>
  //       <Button
  //         onClick={() => {
  //           handleOpenSearch(FormType.SearchTradeData);
  //         }}
  //         color="primary"
  //         startIcon={<IconFeather muiProps={{ fontSize: 'small' }} icon={<Sliders />} />}
  //         variant="text"
  //       >
  //         Advanced Search
  //       </Button>
  //     </Grid>
  //   </Grid>
  // );
  return <></>;
};

export default FilterTradeDataProductList;
